import { FC } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { CHART_SHADOW, CUSTOM_BOOKINGS_TOOLTIP, MONTHS } from "lib/constants";
import { calculateMonthlyData } from "lib/utils/monthly-data-util";

interface ClinicBookingsChartProps {
  bookingData: BookingEntry[];
  subscriptionsData: SubscriptionEntry[];
  width?: string | number;
  height?: string | number;
  className?: string;
}

const ClinicBookingsChart: FC<ClinicBookingsChartProps> = ({
  bookingData,
  subscriptionsData,
  width = "100%",
  height = "100%",
  className,
}) => {
  const { monthlyData: monthlyBookings, yAxisMax: bookingYAxisMax } =
    calculateMonthlyData(bookingData, "bookings");
    
  const { monthlyData: monthlySubs, yAxisMax: subsYAxisMax } =
    calculateMonthlyData(subscriptionsData, "subscriptions");

  const yAxisMax = Math.max(bookingYAxisMax, subsYAxisMax);

  const series = [
    {
      name: "Bookings",
      data: monthlyBookings,
    },
    {
      name: "Subscriptions",
      data: monthlySubs,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
      dropShadow: CHART_SHADOW,
    },
    xaxis: {
      categories: MONTHS,
      title: { text: "Months" },
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      title: { text: "Count" },
      max: yAxisMax,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 4,
      hover: {
        size: 5,
      },
      colors: ["#fff"],
      strokeColors: ["#00E396", "black"],
      strokeWidth: 2,
    },
    colors: ["#00E396", "black"],
    tooltip: {
      custom: CUSTOM_BOOKINGS_TOOLTIP,
    },
    grid: {
      borderColor: "#e0e0e0",
      strokeDashArray: 4,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: "top",
    },
  };
  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      width={width}
      height={height}
      className={className}
    />
  );
};

export default ClinicBookingsChart;
